import { render } from "./TheFeatures.vue?vue&type=template&id=06112b12"
const script = {}

import "./TheFeatures.vue?vue&type=style&index=0&id=06112b12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__